import { skillsBranchLabels } from '../constants/branch-labels';
import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const skillDefinition: FilterDefinition<TreeFilter> = {
  id: FilterId.SKILL,
  name: 'Skill',
  selectionListIds: ['skill_k75', 'skill_k700', 'skill_k3000'],
  selections: [],
  branches: skillsBranchLabels,
  type: FilterType.TREE,
  isVisible: true,
};

export const skillHandler: FilterHandler<TreeFilter> = {
  isActive(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: TreeFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<TreeFilter>) {
    return definition.selectionListIds;
  },
};
